// extracted by mini-css-extract-plugin
export default {"container":"UploadStrapiImage_container__NzmR1","fileName":"UploadStrapiImage_fileName__nEkmz","imageHolder":"UploadStrapiImage_imageHolder__DNMKP"};